type IArquivos = {
    arquivo: any;
    nome: string;
};

type ISubPasta = {
    titleSubPasta: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};
type TItem = {
    title: string;
    materiais: IMaterial[];
};

export const ListMateriasGestaoPlanoAnual: TItem[] = [
    {
        title: 'FoCos',
        materiais: [
            {
                subPastas: [
                    {
                        titleSubPasta: 'FoCos - Benefícios',
                        arquivos: [
                            {
                                nome: 'FOCO_1_CompetenciasSocioemocionais',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Benefícios/FOCO_1_CompetenciasSocioemocionais.pdf',
                            },
                            {
                                nome: 'FOCO_2_DesempenhoEscolar',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Benefícios/FOCO_2_DesempenhoEscolar.pdf',
                            },
                            {
                                nome: 'FOCO_3_ViolenciaEscolar_Bullying',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Benefícios/FOCO_3_ViolenciaEscolar_Bullying.pdf',
                            },
                            {
                                nome: 'FOCO_4_SaudeMental_BemEstar',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Benefícios/FOCO_4_SaudeMental_BemEstar.pdf',
                            },
                            {
                                nome: 'FOCO_5_PertencimentoEscolar',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Benefícios/FOCO_5_PertencimentoEscolar.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'FoCos - Educação Integral',
                        arquivos: [
                            {
                                nome: 'GN10_Foco_IAS_1_Educacao_integral',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Educação Integral/GN10_Foco_IAS_1_Educacao_integral.pdf',
                            },
                            {
                                nome: 'GN10_Foco_IAS_2_Lideranca',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Educação Integral/GN10_Foco_IAS_2_Lideranca.pdf',
                            },
                            {
                                nome: 'GN10_Foco_IAS_3_Evidencias',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Educação Integral/GN10_Foco_IAS_3_Evidencias.pdf',
                            },
                            {
                                nome: 'GN10_Foco_IAS_4_Diretor como gestor de transformacao',
                                arquivo:
                                    'GN10_Materiais_2026/FoCos/FoCos - Educação Integral/GN10_Foco_IAS_4_Diretor como gestor de transformacao.pdf',
                            },
                            {
                                nome: 'GN10_Foco_IAS_5_Intervencoes',
                                arquivo: 'GN10_Materiais_2026/FoCos/FoCos - Educação Integral/GN10_Foco_IAS_5_Intervencoes.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: 'Textos Anexos',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'GN10_Ciclo1_Apresentacao_Anexos',
                        arquivo: 'GN10_Materiais_2026/TEXTOS ANEXOS/GN10_Ciclo1_Apresentacao_Anexos.pdf',
                    },
                    {
                        nome: 'GN10_Ciclo2_RotinasEscolares_Anexos',
                        arquivo: 'GN10_Materiais_2026/TEXTOS ANEXOS/GN10_Ciclo2_RotinasEscolares_Anexos.pdf',
                    },
                    {
                        nome: 'GN10_Ciclo3_GestaoEscolar_Anexos',
                        arquivo: 'GN10_Materiais_2026/TEXTOS ANEXOS/GN10_Ciclo3_GestaoEscolar_Anexos.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Visão Geral e Sistemática de Acompanhamento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'GESTAO_NOTA_10_SISTEMATICA DE ACOMPANHAMENTO',
                        arquivo:
                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/GESTAO_NOTA_10_SISTEMATICA DE ACOMPANHAMENTO.pdf',
                    },
                    {
                        nome: 'GN10_Documento_Geral',
                        arquivo: 'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/GN10_Documento_Geral.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Cartazes',
                        arquivos: [
                            {
                                nome: 'GN10_cartaz_ACOMPANHAMENTO MENSAL I A (ANOS INICIAIS)',
                                arquivo:
                                    'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Cartazes/GN10_cartaz_ACOMPANHAMENTO MENSAL I A (ANOS INICIAIS).pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Relatórios Qualitativos',
                        arquivos: [
                            {
                                nome: 'GESTAO_NOTA_10_Formulario_A_horizontal',
                                arquivo:
                                    'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/GESTAO_NOTA_10_Formulario_A_horizontal.pdf',
                            },
                            {
                                nome: 'GESTAO_NOTA_10_Formulario_B',
                                arquivo:
                                    'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/GESTAO_NOTA_10_Formulario_B.pdf',
                            },
                            {
                                nome: 'GESTAO_NOTA_10_Formulario_C',
                                arquivo:
                                    'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/GESTAO_NOTA_10_Formulario_C.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Tabelas',
                        subPastas: [
                            {
                                titleSubPasta: 'Anos Iniciais',
                                arquivos: [
                                    {
                                        nome: 'GN10_tabela_ACOMPANHAMENTO BIMESTRAL I (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_ACOMPANHAMENTO BIMESTRAL I (ANOS INICIAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_ACOMPANHAMENTO BIMESTRAL II (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_ACOMPANHAMENTO BIMESTRAL II (ANOS INICIAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_ACOMPANHAMENTO MENSAL - FALTAS - I B (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_ACOMPANHAMENTO MENSAL - FALTAS - I B (ANOS INICIAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_ACOMPANHAMENTO MENSAL II (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_ACOMPANHAMENTO MENSAL II (ANOS INICIAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_PERFIL DA TURMA I (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_PERFIL DA TURMA I (ANOS INICIAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_PERFIL DA TURMA II (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_PERFIL DA TURMA II (ANOS INICIAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_RESULTADO FINAL I (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_RESULTADO FINAL I (ANOS INICIAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_RESULTADO FINAL II (ANOS INICIAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Iniciais/GN10_tabela_RESULTADO FINAL II (ANOS INICIAIS).pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Anos Finais',
                                arquivos: [
                                    {
                                        nome: 'GN10_tabela_ACOMPANHAMENTO BIMESTRAL I (ANOS FINAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Finais/GN10_tabela_ACOMPANHAMENTO BIMESTRAL I (ANOS FINAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_ACOMPANHAMENTO BIMESTRAL II (ANOS FINAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Finais/GN10_tabela_ACOMPANHAMENTO BIMESTRAL II (ANOS FINAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_PERFIL DA TURMA I (ANOS FINAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Finais/GN10_tabela_PERFIL DA TURMA I (ANOS FINAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_PERFIL DA TURMA II (ANOS FINAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Finais/GN10_tabela_PERFIL DA TURMA II (ANOS FINAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_RESULTADO FINAL I (ANOS FINAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Finais/GN10_tabela_RESULTADO FINAL I (ANOS FINAIS).pdf',
                                    },
                                    {
                                        nome: 'GN10_tabela_RESULTADO FINAL II (ANOS FINAIS)',
                                        arquivo:
                                            'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Anos Finais/GN10_tabela_RESULTADO FINAL II (ANOS FINAIS).pdf',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
